import { render, staticRenderFns } from "./unbindOTP2fa.vue?vue&type=template&id=39c4ead8&scoped=true&lang=pug&"
import script from "./unbindOTP2fa.vue?vue&type=script&lang=js&"
export * from "./unbindOTP2fa.vue?vue&type=script&lang=js&"
import style0 from "./unbindOTP2fa.vue?vue&type=style&index=0&id=39c4ead8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4ead8",
  null
  
)

export default component.exports